import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkText } from "uitk-react-text";
import { UitkCard, UitkCardMedia, UitkCardContent, UitkCardTextSegment, UitkCardLink } from "uitk-react-cards";

import ProductIcon from "./ProductIcon";
import ProductDateSupportText from "./ProductDateSupportText";
import ProductPriceSupportText from "./ProductPriceSupportText";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { CityCardDestination } from "typings/microserviceModels/top-cities-flex-module";

const ImageTopCardCityCard = (props: { city: CityCardDestination }) => {
  const { city } = props;
  const { name: cityName, link, deal } = city;
  const mainImage = city.images[0];
  const { formatText } = useLocalization();

  return (
    <UitkCard>
      <UitkCardMedia>
        <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
          <UitkImage
            src={mainImage.url}
            alt={mainImage.alt}
            placeholderImage={true}
            className="uitk-rounded-border-top"
          />

          <ProductIcon />
        </UitkFigure>
      </UitkCardMedia>

      <UitkCardContent>
        <UitkCardTextSegment>
          <UitkLayoutFlex direction="column">
            <UitkLayoutFlex direction="column">
              <UitkText className="uitk-type-heading-500">{cityName}</UitkText>
              <ProductDateSupportText deal={deal} />
            </UitkLayoutFlex>

            {deal && (
              <UitkLayoutFlex direction="column" className="uitk-type-right">
                <div
                  className="uitk-type-heading-300"
                  dangerouslySetInnerHTML={{
                    __html: formatText("topCities.productPrice", deal.priceFormatted),
                  }}
                />
                <ProductPriceSupportText />
              </UitkLayoutFlex>
            )}
          </UitkLayoutFlex>
        </UitkCardTextSegment>
      </UitkCardContent>

      <UitkCardLink>
        <TrackedLink
          moduleName="topCities"
          rfrr="hotelTravelGuideLink"
          href={link}
          data-testid={`top-cities-image-top-card-${cityName}`}
        >
          {cityName}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default ImageTopCardCityCard;
